import { Text } from "@microbeta/ui";
import clsx from "clsx";
import type { FC } from "react";
import LogoSvg from "../../../assets/images/microbeta-no-bg.png";
import styles from "./microbeta-logo.module.scss";

interface Props {
  className?: string;
}

export const MicrobetaLogo: FC<Props> = ({ className }) => {
  return (
    <div className={clsx(styles.logo, className)}>
      <img className={styles.img} src={LogoSvg} alt="Microbeta logo" />
      <Text variant="large" className={styles.logoText}>
        Microbeta
      </Text>
    </div>
  );
};
